import { render, staticRenderFns } from "./DepartmentView01.vue?vue&type=template&id=b63ffdae&scoped=true&"
import script from "./DepartmentView01.vue?vue&type=script&lang=js&"
export * from "./DepartmentView01.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentView01.vue?vue&type=style&index=0&id=b63ffdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63ffdae",
  null
  
)

export default component.exports